// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".co-body[data-v-478e0e44]{padding:28px;text-align:center}.cdlg-title[data-v-478e0e44]{margin:0 0 10px}.co-hint[data-v-478e0e44]{margin:0;color:#afc0d5;font-size:13px}.co-buttons[data-v-478e0e44]{display:flex;gap:16px;justify-content:center;margin-top:22px}.co-buttons .cdlg-btn[data-v-478e0e44]{min-width:110px;min-height:42px}", ""]);
// Exports
module.exports = exports;
